import React, { useEffect } from 'react';
import './Notifications.css';
import Axios from 'axios';
import authClient from '../auth/Auth';
import { generateMandatoryDataField, mandatoryData } from './../form/UserProperties';
import { printHttpError, generateDataToSend } from './../utils/Utils';
import { API, AppId, Messages, topics } from './../constants/constants';
import { mainFields, notificationType, mainTopics } from './NotificationHelper.js';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Slide from '@material-ui/core/Slide';
import Snackbar from '@material-ui/core/Snackbar';

function TransitionDown(props) {
  return <Slide {...props} direction="down" />;
}

const formData = {};
const useStyles = makeStyles(theme => ({
  button: {
    minWidth: "100px",
    marginLeft: "20px",
    marginRight: "20px"
  },
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  }
}));

export default function Notifications(props) {
  const classes = useStyles();
  const [targetedUsers, setTargetedUsers] = React.useState(-1);
  const [selectedTopic, setSelectedTopic] = React.useState(null);
  const [title, setTitle] = React.useState(null);
  const [metaData, setMetaData] = React.useState({});
  const [text, setText] = React.useState(null);
  const [snackMsg, setSnackMsg] = React.useState("");
  const [snackClass, setSnackClass] = React.useState("");
  const [imageUrl, setImageUrl] = React.useState(null);
  const [thumbUrl, setThumbUrl] = React.useState(null);
  const [isPLoading, setPLoading] = React.useState(false);
  const [isSLoading, setSLoading] = React.useState(false);
  const [isStaging, setStaging] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [clientId, setClientId] = React.useState(null);
  const [affiliateId, setAffiliateId] = React.useState(null);

  /** A callback function to save field value changes */
  function handleValueChange(key, value) {
    formData[key] = value;
    if (formData.type && formData.type.value === 'link') {
      delete formData.tyReply;
    } else if (formData.type && formData.type.value === 'reply') {
      delete formData.keyUrl;
    }
    setSelectedTopic(formData.topic);

    if (key === mandatoryData.clientId.name) {
      if (value && metaData[value.value]) {
        setClientId(value.value);
      } else {
        setClientId(null);
        delete formData[key];
      }
    }
    if (key === mandatoryData.affiliateId.name) {
      if (value && metaData[clientId] && metaData[clientId][value.value]) {
        setAffiliateId(value.value);
      } else {
        setAffiliateId(null);
        delete formData[key];
      }
    }
    if (key === "title") {
      setTitle(value.value);
    } else if (key === "text") {
      setText(value.value);
    } else if (key === "imageUrl") {
      setImageUrl(value.value);
    } else if (key === "thumbUrl") {
      setThumbUrl(value.value);
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setStaging(props.isStaging);
    setMetaData({});
    setClientId(null);
    setAffiliateId(null);
    Axios.get(props.isStaging ? API.staging.clientMetadata : API.production.clientMetadata, {
      headers: { 'x-access-token': authClient.getIdToken() }
    })
      .then(response => {
        if (response && response.data && response.data.data) {
          setMetaData(response.data.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
        // always executed
        console.log("call finished");
      });
  }, [props.isStaging]);

  function openSnack(isSuccess, msg) {
    setSnackClass(isSuccess ? classes.success : classes.error);
    setSnackMsg(msg);
    setOpen(true);
  }

  /** 
  * Prepare function that retrieves number of available users and prints it in brackets of send
  * notification button of the web app
  */
  function handlePrepare(e) {
    setTargetedUsers(-1);
    e.preventDefault();
    console.log("handlePrepare");
    console.log(formData);
    let dataToSend = generateDataToSend(formData);
    if (!dataToSend) {
      return;
    }
    console.log(dataToSend);
    setPLoading(true);
    Axios.get(props.isStaging ? API.staging.audience : API.production.audience, {
      params: {
        ...dataToSend.target,
        topic: dataToSend.topic,
      },
      headers: { 'x-access-token': authClient.getIdToken() }
    })
      .then(response => {
        console.log(response);
        if (response.data) {
          setTargetedUsers(response.data.data);
          openSnack(true, "Targeted users: " + response.data.data);
        }
      })
      .catch(error => {
        openSnack(false, printHttpError(error));
      })
      .then(() => {
        // always executed
        console.log("call finished");
        setPLoading(false);
      });
  }

  /**
   * Sends the notification from the form data
   */
  function handleSend(e) {
    e.preventDefault();
    console.log("handleSend");
    let dataToSend = generateDataToSend(formData);

    if (dataToSend) {
      setSLoading(true);
      Axios.post(props.isStaging ? API.staging.notification : API.production.notification,
        { data: dataToSend },
        { headers: { 'x-access-token': authClient.getIdToken() } })
        .then(response => {
          console.log(response);
          openSnack(true, "Sent successfully");
        })
        .catch(function (error) {
          console.log(error);
          let er = JSON.stringify(error);
          openSnack(false, er);
        })
        .then(function () {
          setSLoading(false);
        });
    }
  }

  return (
    <div className="Notifications">
      <div className="Notifications-left-column">
        <form id="form">

          {mainFields(handleValueChange, props.isStaging)}
          {mainTopics(handleValueChange, props.isStaging)}

          <div className="Notifications-user-properties">User properties:</div>
          {selectedTopic && selectedTopic.value === topics(isStaging)[1] ? <div className="Notifications-warning">{Messages.userPropertyWarning}</div> : null}

          {generateMandatoryDataField(mandatoryData.clientId, Object.keys(metaData), handleValueChange)}
          {clientId ? generateMandatoryDataField(mandatoryData.affiliateId, Object.keys(metaData[clientId]), handleValueChange) : null}
          {affiliateId ? generateMandatoryDataField(mandatoryData.appId, metaData[clientId][affiliateId].map(id => AppId(id)), handleValueChange) : null}

          {notificationType(handleValueChange, selectedTopic, isStaging)}

          <div className="Notifications-buttons">
            <Button className={classes.button} variant="contained" color="secondary" onClick={handlePrepare}>
              <div>
                Prepare
                {isPLoading ? <LinearProgress /> : null}
              </div>
            </Button>

            <Button className={classes.button} variant="contained" color="primary" onClick={handleSend}>
              <div>
                Send ({targetedUsers >= 0 ? targetedUsers : 0})
                {isSLoading ? <LinearProgress /> : null}
              </div>
            </Button>
          </div>
        </form>
        <Snackbar
          open={open}
          onClose={handleClose}
          TransitionComponent={TransitionDown}
          className={snackClass}
          autoHideDuration={2000}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={
            <span>{snackMsg}</span>
          }
        />
      </div>
      <div className="Notifications-right-column">
        <h1>Initial state</h1>
        <div className="Notifications-notification">
          <div className="Notifications-notification-bg">
            <div className="Notifications-notification-title">{title
              ? title
              : "Sample title"}</div>
            <div className="Notifications-notification-text">{text
              ? text
              : "Sample text"}</div>
            <img alt="" className="Notifications-notification-thumb" src={thumbUrl
              ? thumbUrl
              : 'https://www.gstatic.com/mobilesdk/180130_mobilesdk/images/image_placeholder.png'} />
          </div>
        </div>
        <h1>Expanded view</h1>
        <div className="Notifications-notification Notifications-notification-second">
          <div className="Notifications-notification-bg">
            <div className="Notifications-notification-title">{title
              ? title
              : "Sample title"}</div>
            <div className="Notifications-notification-text">{text
              ? text
              : "Sample text"}</div>
            <img alt="" className="Notifications-notification-image" src={imageUrl
              ? imageUrl
              : 'https://www.gstatic.com/mobilesdk/190408_mobilesdk/landscape_image_placeholder.png'} />

          </div>
        </div>
      </div>
    </div>
  );
}